import { PropertySubTypeEnum, PropertyTypeEnum } from '@engelvoelkersamericas/api';
import { FC } from 'react';
import { CheckboxSectionWithArrayOfObject } from '../CheckboxSection';
import { ModalHeader, ModalSection } from '../styles';
import { useTranslations } from 'next-intl';

interface ForSaleSectionProps {
  propertyTypes: { title: string; value: PropertySubTypeEnum[] }[];
  selectedPropertyTypes?: PropertySubTypeEnum[];
  listingTypes: { title: string; value: PropertyTypeEnum[] }[];
  selectedListingTypes?: PropertyTypeEnum[];
  handleSetCheckbox: (type: string, b: string | string[]) => void;
  hideRentFilters?: boolean;
}

export const ForSaleSection: FC<ForSaleSectionProps> = ({
  propertyTypes,
  selectedPropertyTypes,
  listingTypes,
  selectedListingTypes,
  handleSetCheckbox,
  hideRentFilters,
}) => {
  const t = useTranslations();
  return (
    <ModalSection data-testid="listing-property-type-filters">
      {!hideRentFilters && (
        <>
          <ModalHeader data-testid="listing-type-header">{t('Listing Type')}</ModalHeader>
          <CheckboxSectionWithArrayOfObject
            items={listingTypes}
            handleSetSelected={handleSetCheckbox}
            selectedArr={selectedListingTypes}
            type="listing_type"
            style={{ marginBottom: '1rem' }}
          />
        </>
      )}
      <ModalHeader data-testid="property-type-header">{t('Property Type')}</ModalHeader>
      {propertyTypes && (
        <CheckboxSectionWithArrayOfObject
          items={propertyTypes}
          handleSetSelected={handleSetCheckbox}
          selectedArr={selectedPropertyTypes}
          type="property_type"
        />
      )}
    </ModalSection>
  );
};
